// @flow

import React, { PureComponent } from 'react';
import type { Node } from 'react';
import cx from 'classnames';

type Props = {
  children: Node,
  className?: string, // 'ghost-button', 'cta-button', 'card-button', 'transparent'
  clickHandler?: Function,
  forwardRef: HTMLButtonElement | null,
  isDisabled?: boolean,
  isOnboarding?: boolean,
  size?: string, // 'sm', 'med', 'lg'
  style?: StyleType,
};

class Button extends PureComponent<Props> {
  static defaultProps = {
    className: '',
    clickHandler: () => null,
    forwardRef: null,
    isDisabled: false,
    isOnboarding: false,
    size: 'med',
    style: {},
  };

  render() {
    const {
      children,
      className,
      clickHandler,
      forwardRef,
      isDisabled,
      isOnboarding,
      size,
      style,
      ...rest
    } = this.props;
    const buttonClasses = cx(
      'button full',
      className,
      size,
      { disabled: isDisabled },
      { onboarding: isOnboarding },
    );

    return (
      <button
        {...rest}
        ref={forwardRef}
        className={buttonClasses}
        style={{
          ...style,
        }}
        onClick={isDisabled ? e => e.preventDefault() : clickHandler}>
        {children}
      </button>
    );
  }
}

export default Button;
